// // import React, { useContext, useEffect, useState } from "react";
// // import Icon from "../../../components/AppIcon";
// // import Button from "../../../components/ui/Button";
// // import Select from "../../../components/ui/Select";
// // import Input from "../../../components/ui/Input";
// // import { DataContext } from "context/DataContext";
// // import apiUtils from "utils/apiutils";

// // // Wrapper component to ensure plain value display in the input field
// // const CustomSelect = ({ options, value, onChange, ...props }) => {
// //   const selectedOption = options.find((opt) => opt.value === value);
// //   const displayValue = selectedOption ? selectedOption.value : value;

// //   return (
// //     <Select
// //       {...props}
// //       options={options.map((opt) => ({
// //         ...opt,
// //         label: opt.dropdownLabel || opt.label, // Use dropdownLabel for dropdown rendering
// //       }))}
// //       value={displayValue}
// //       onChange={onChange}
// //     />
// //   );
// // };

// // const TradingConditions = ({
// //   conditions,
// //   onConditionsChange,
// //   botConfig,
// //   selectedMainStrategy,
// //   apis,
// //   onFinalFieldChange,
// //   selectedMode,
// //   handleCreateBot,
// // }) => {
// //   const [activeTab, setActiveTab] = useState("entry");
// //   const { myexchanges, coins, handegetcoins, handlegetexchanges } =
// //     useContext(DataContext);
// //   const [exchanges, setExchanges] = useState([]);
// //   console.log("selectedMode", selectedMode);


// //   const [symbols, setSymbols] = useState([]);

// //   const [leverage, setLeverage] = useState([]); // State for leverage options
// //   const [isLoadingSymbols, setIsLoadingSymbols] = useState(false);
// //   const [isLoadingLeverage, setIsLoadingLeverage] = useState(false); // Loading state for leverage
// //   // Fetch exchanges
// //   const handegetExchanges = async () => {
// //     try {
// //       const resp = await apiUtils.post("/api/get_exchange_name", {
// //         showToast: false,
// //       });
// //       if (resp?.Success) setExchanges(resp.Success);
// //     } catch (e) {
// //       console.error("Error fetching exchanges:", e);
// //     }
// //   };

// //   // Fetch symbols
// //   const handegetSymbols = async (exchange) => {
// //     if (!exchange) return;
// //     setIsLoadingSymbols(true);
// //     const payloads = {
// //       exchange: exchange,
// //       exchange_type: botConfig.exchange_type || "spot",
// //     };
// //     try {
// //       const resp = await apiUtils.post("/api/get_exchange_symbols", payloads, {
// //         showToast: false,
// //       });
// //       if (resp?.Success?.Symbols) {
// //         setSymbols(resp.Success.Symbols);
// //       }
// //     } catch (e) {
// //       console.error("Error fetching symbols:", e);
// //     } finally {
// //       setIsLoadingSymbols(false);
// //     }
// //   };

// //   // Fetch leverage options
// //   const handegetExchangesLeverage = async () => {
// //     setIsLoadingLeverage(true);
// //     try {
// //       const resp = await apiUtils.post("/bot/view_leverage_dropdown", {
// //         showToast: false,
// //       });
// //       console.log("Leverage API response:", resp); // Debug log
// //       if (resp?.Success?.Static_List) {
// //         setLeverage(resp.Static_List);
// //       } else {
// //         console.error("No leverage data found in response");
// //         setLeverage(["5", "10", "20"]); // Fallback options
// //       }
// //     } catch (e) {
// //       console.error("Error fetching leverage:", e);
// //       setLeverage(["5", "10", "20"]); // Fallback options on error
// //     } finally {
// //       setIsLoadingLeverage(false);
// //     }
// //   };

// //   /* --------------------------------------------------------------
// //      FETCH DATA (once for exchanges, coins, and leverage)
// //   -------------------------------------------------------------- */
// //   useEffect(() => {
// //     handegetcoins?.();
// //     handegetExchanges?.();
// //     handlegetexchanges?.();
// //     handegetExchangesLeverage(); // Fetch leverage on mount
// //   }, []);

// //   /* --------------------------------------------------------------
// //      FETCH SYMBOLS WHEN EXCHANGE CHANGES
// //   -------------------------------------------------------------- */
// //   useEffect(() => {
// //     const selectedExchange = conditions.entry?.[0]?.exchange;
// //     if (selectedExchange) {
// //       handegetSymbols(selectedExchange);
// //     } else {
// //       setSymbols([]);
// //     }
// //   }, [conditions.entry?.[0]?.exchange]);

// //   /* --------------------------------------------------------------
// //      OPTIONS
// //   -------------------------------------------------------------- */
// //   const apiNameOptions = apis.map((a) => ({
// //     value: a.ApiID,
// //     label: a.Api_Name,
// //     exchange: a.Exchange,
// //   }));
// //   const leverageOptions = leverage.map((v) => ({ value: v, label: v })); 
// //   const tpTypeOptions = [
// //     { value: "Pair_Price", label: "Pair Price" },
// //     { value: "Pair_Value", label: "Pair Value" },
// //   ];


// //   const exchangeOptions = exchanges

// //     .map((ex) => ({
// //       value: ex,
// //       searchableText: ex,
// //       label: (
// //         <div className="flex items-center gap-2">
// //           <span>{ex.toUpperCase()}</span>
// //         </div>
// //       ),
// //     }));

// //   const coinOptions = symbols

// //     .map((c) => ({
// //       value: c,
// //       searchableText: c,
// //       label: c.symbol,
// //       dropdownLabel: (
// //         <div className="flex items-center gap-2">
// //           <span>{c.toUpperCase()}</span>
// //         </div>
// //       ),
// //     }));

// //   /* --------------------------------------------------------------
// //      CONDITION HELPERS
// //   -------------------------------------------------------------- */
// //   const addCondition = (type) => {
// //     const newCond = {
// //       id: Date.now(),
// //       apiName: "",
// //       leverage: "",
// //       symbol: "",
// //       bot_name: "",
// //       tp_type: "",
// //       exchange: "",
// //       investment_long: "",
// //       investment_short: "",
// //       enabled: true,
// //     };
// //     onConditionsChange({
// //       ...conditions,
// //       [type]: [...(conditions[type] || []), newCond],
// //     });
// //   };

// //   const updateCondition = (type, id, field, value) => {
// //     const updated = (conditions[type] || []).map((c) =>
// //       c.id === id ? { ...c, [field]: value } : c
// //     );
// //     onConditionsChange({ ...conditions, [type]: updated });
// //     if (field === "exchange" && type === "entry") {
// //       handegetSymbols(value);
// //       onConditionsChange({
// //         ...conditions,
// //         [type]: updated.map((c) => (c.id === id ? { ...c, symbol: "" } : c)),
// //       });
// //     }
// //   };

// //   const removeCondition = (type, id) => {
// //     const filtered = (conditions[type] || []).filter((c) => c.id !== id);
// //     onConditionsChange({ ...conditions, [type]: filtered });
// //   };

// //   /* --------------------------------------------------------------
// //      TAB ORDER
// //   -------------------------------------------------------------- */
// //   const tabOrder = ["entry", "stoploss", "takeprofit", "final"];

// //   const nextTab = () => {
// //     const idx = tabOrder.indexOf(activeTab);
// //     if (idx < tabOrder.length - 1) setActiveTab(tabOrder[idx + 1]);
// //   };

// //   /* --------------------------------------------------------------
// //      VALIDATION FOR EACH TAB
// //   -------------------------------------------------------------- */
// //   const isEntryValid = () => {
// //     const list = conditions.entry || [];
// //     return (
// //       list.length > 0 &&
// //       list.every(
// //         (c) =>
// //           c.apiName &&
// //           c.leverage &&
// //           c.symbol &&
// //           c.bot_name &&
// //           (selectedMainStrategy === "Liquidation" && c.tp_type) ||
// //           c.exchange
// //       )
// //     );
// //   };

// //   const isStopLossValid = () =>
// //     botConfig.stopLossLong && botConfig.stopLossShort;
// //   const isTakeProfitValid = () =>
// //     botConfig.takeProfitLong && botConfig.takeProfitShort;

// //   const isFinalValid = () => {
// //     const e = conditions.entry?.[0] || {};
// //     return (
// //       e.apiName &&
// //       e.leverage &&
// //       e.symbol &&
// //       e.bot_name &&
// //       e.tp_type &&
// //       e.exchange &&
// //       botConfig.takeProfitLong &&
// //       botConfig.takeProfitShort &&
// //       botConfig.stopLossLong &&
// //       botConfig.stopLossShort
// //     );
// //   };

// //   /* --------------------------------------------------------------
// //      RENDER EACH TAB
// //   -------------------------------------------------------------- */
// //   const renderTabContent = () => {
// //     /* ---------- ENTRY ---------- */
// //     if (activeTab === "entry") {
// //       const list = conditions.entry || [];
// //       console.log("l", list);

// //       return (
// //         <div className="space-y-6">
// //           {list.length === 0 ? (
// //             <div className="text-center py-8">
// //               <Button
// //                 onClick={() => addCondition("entry")}
// //                 iconName="Plus"
// //                 iconPosition="left"
// //               >
// //                 Add Configuration
// //               </Button>
// //             </div>
// //           ) : (
// //             list.map((cond, i) => {
// //               const selectedApi = apis.find((a) => a.ApiID === cond.apiName);
// //               const tradeType = selectedApi ? selectedApi.Trade_Type : "";

// //               return (
// //                 <div
// //                   key={cond.id}
// //                   className="bg-card border border-border rounded-lg p-4"
// //                 >
// //                   <div className="flex items-center justify-between mb-4">
// //                     <span className="text-sm font-medium text-foreground">
// //                       Add Condition
// //                     </span>
// //                     <div className="flex items-center space-x-2">
// //                       <span className="text-xs font-medium text-primary">
// //                         {tradeType}
// //                       </span>
// //                     </div>
// //                   </div>

// //                   <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
// //                     <Select
// //                       label="Api Name"
// //                       tooltip="Select the API credentials to use for this bot."
// //                       options={apiNameOptions}
// //                       value={cond.apiName ?? ""}
// //                       onChange={(v) => {
// //                         const selectedApi = apiNameOptions.find(a => a.value === v);

// //                         const newCondition = {
// //                           apiName: v,
// //                           exchange: selectedApi?.exchange || cond.exchange
// //                         };

// //                         const updated = (conditions.entry || []).map((c) =>
// //                           c.id === cond.id ? { ...c, ...newCondition } : c
// //                         );

// //                         onConditionsChange({ ...conditions, entry: updated });
// //                       }}

// //                       placeholder="Select Api Name"
// //                     />
// //                     <Select
// //                       tooltip="Select the leverage multiplier (example: 1x, 2x, 5x)."
// //                       label="Leverage (x)"
// //                       options={leverageOptions}
// //                       value={cond.leverage ?? ""}
// //                       onChange={(v) =>
// //                         updateCondition("entry", cond.id, "leverage", v)
// //                       }
// //                       placeholder={
// //                         isLoadingLeverage ? "Loading leverage..." : "Select Leverage"
// //                       }
// //                       disabled={isLoadingLeverage || leverage.length === 0}
// //                     />
// //                     <Select
// //                       label="Exchange"
// //                       tooltip="Choose the exchange where you want to run create the bot."
// //                       options={exchangeOptions}
// //                       value={cond.exchange ?? ""}
// //                       onChange={(v) =>
// //                         updateCondition("entry", cond.id, "exchange", v)
// //                       }
// //                       placeholder="Select Exchange"
// //                       type="exchange"
// //                       disabled={!!cond.apiName} />
// //                     <CustomSelect
// //                       label="Symbol"
// //                       tooltip="Choose the trading pair for create the bot (example: BTCUSDT)."
// //                       options={coinOptions.map((opt) => ({
// //                         ...opt,
// //                         label: opt.dropdownLabel,
// //                       }))}
// //                       value={cond.symbol ?? ""}
// //                       onChange={(v) =>
// //                         updateCondition("entry", cond.id, "symbol", v)
// //                       }
// //                       placeholder={
// //                         isLoadingSymbols ? "Loading symbols..." : "Select Coin"
// //                       }
// //                       type="coin"
// //                       disabled={!cond.exchange || isLoadingSymbols}
// //                     />
// //                     <Input
// //                       label="Bot Name"
// //                       tooltip="Enter a unique name for your trading bot."
// //                       type="text"
// //                       value={cond.bot_name ?? ""}
// //                       onChange={(e) =>
// //                         updateCondition(
// //                           "entry",
// //                           cond.id,
// //                           "bot_name",
// //                           e.target.value
// //                         )
// //                       }
// //                       placeholder="Enter bot name"
// //                     />
// //                     {selectedMainStrategy === "Liquidation" && (
// //                       <Select
// //                         label="TP Type"
// //                         tooltip="Select the take profit calculation method."
// //                         options={tpTypeOptions}
// //                         value={cond.tp_type ?? ""}
// //                         onChange={(v) =>
// //                           updateCondition("entry", cond.id, "tp_type", v)
// //                         }
// //                         placeholder="Select TP Type"
// //                       />
// //                     )}

// //                     {/* LONG ONLY */}
// //                     {selectedMode === "long-only" && (
// //                       <Input
// //                         label="Investment Long ($)"
// //                         tooltip="Set the amount to invest in long positions."
// //                         type="number"
// //                         value={cond.investment_long ?? ""}
// //                         onChange={(e) =>
// //                           updateCondition(
// //                             "entry",
// //                             cond.id,
// //                             "investment_long",
// //                             e.target.value
// //                           )
// //                         }
// //                         placeholder="0.00"
// //                       />
// //                     )}

// //                     {/* SHORT ONLY */}
// //                     {selectedMode === "short-only" && (
// //                       <Input
// //                         label="Investment Short ($)"
// //                         tooltip="Set the amount to invest in short positions."
// //                         type="number"
// //                         value={cond.investment_short ?? ""}
// //                         onChange={(e) =>
// //                           updateCondition(
// //                             "entry",
// //                             cond.id,
// //                             "investment_short",
// //                             e.target.value
// //                           )
// //                         }
// //                         placeholder="0.00"
// //                       />
// //                     )}

// //                     {/* BOTH SHOW (When not long-only & not short-only) */}
// //                     {selectedMode !== "long-only" && selectedMode !== "short-only" && (
// //                       <>
// //                         <Input
// //                           label="Investment Long ($)"
// //                           tooltip="Set the amount to invest in long positions."
// //                           type="number"
// //                           value={cond.investment_long ?? ""}
// //                           onChange={(e) =>
// //                             updateCondition(
// //                               "entry",
// //                               cond.id,
// //                               "investment_long",
// //                               e.target.value
// //                             )
// //                           }
// //                           placeholder="0.00"
// //                         />
// //                         <Input
// //                           label="Investment Short ($)"
// //                           tooltip="Set the amount to invest in short positions."
// //                           type="number"
// //                           value={cond.investment_short ?? ""}
// //                           onChange={(e) =>
// //                             updateCondition(
// //                               "entry",
// //                               cond.id,
// //                               "investment_short",
// //                               e.target.value
// //                             )
// //                           }
// //                           placeholder="0.00"
// //                         />
// //                       </>
// //                     )}
// //                   </div>
// //                 </div>
// //               );
// //             })
// //           )}

// //           {/* NEXT BUTTON */}
// //           {isEntryValid() && (
// //             <div className="mt-6 flex justify-end items-center">
// //               <Button variant="default" className="px-8" onClick={nextTab}>
// //                 Next
// //               </Button>
// //             </div>
// //           )}
// //         </div>
// //       );
// //     }

// //     /* ---------- STOP LOSS ---------- */
// //     if (activeTab === "stoploss") {
// //       return (
// //         <div className="space-y-6">
// //           <div className="text-center mb-6">
// //             <h4 className="text-lg the font-semibold">Set Stop Loss (%)</h4>
// //           </div>
// //           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

// //             {selectedMode === "long-only" && (
// //               <Input
// //                 label="Stop Loss Long (%)"
// //                 tooltip="Set the stop loss percentage for long positions."
// //                 type="number"
// //                 value={botConfig.stopLossLong}
// //                 onChange={(e) =>
// //                   onFinalFieldChange("stopLossLong", e.target.value)
// //                 }
// //                 placeholder="5"
// //               />
// //             )}

// //             {/* SHORT ONLY */}
// //             {selectedMode === "short-only" && (
// //               <Input
// //                 label="Stop Loss Short (%)"
// //                 tooltip="Set the stop loss percentage for short positions."
// //                 type="number"
// //                 value={botConfig.stopLossShort}
// //                 onChange={(e) =>
// //                   onFinalFieldChange("stopLossShort", e.target.value)
// //                 }
// //                 placeholder="5"
// //               />
// //             )}

// //             {/* BOTH SHOW (When not long-only & not short-only) */}
// //             {selectedMode !== "long-only" && selectedMode !== "short-only" && (
// //               <>
// //                 <Input
// //                   label="Stop Loss Long (%)"
// //                   tooltip="Set the stop loss percentage for long positions."
// //                   type="number"
// //                   value={botConfig.stopLossLong}
// //                   onChange={(e) =>
// //                     onFinalFieldChange("stopLossLong", e.target.value)
// //                   }
// //                   placeholder="5"
// //                 />
// //                 <Input
// //                   label="Stop Loss Short (%)"
// //                   tooltip="Set the stop loss percentage for short positions."
// //                   type="number"
// //                   value={botConfig.stopLossShort}
// //                   onChange={(e) =>
// //                     onFinalFieldChange("stopLossShort", e.target.value)
// //                   }
// //                   placeholder="5"
// //                 />
// //               </>
// //             )}
// //           </div>

// //           {isStopLossValid() && (
// //             <div className="mt-6 flex justify-end items-center">
// //               <Button variant="default" className="px-8" onClick={nextTab}>
// //                 Next
// //               </Button>
// //             </div>
// //           )}
// //         </div>
// //       );
// //     }

// //     /* ---------- TAKE PROFIT ---------- */
// //     if (activeTab === "takeprofit") {
// //       return (
// //         <div className="space-y-6">
// //           <div className="text-center mb-6">
// //             <h4 className="text-lg font-semibold">Set Take Profit (%)</h4>
// //           </div>
// //           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


// //             {selectedMode === "long-only" && (
// //               <Input
// //                 label="Take Profit Long (%)"
// //                 tooltip="Set the take profit percentage for long positions."
// //                 type="number"
// //                 value={botConfig.takeProfitLong}
// //                 onChange={(e) =>
// //                   onFinalFieldChange("takeProfitLong", e.target.value)
// //                 }
// //                 placeholder="10"
// //               />
// //             )}

// //             {/* SHORT ONLY */}
// //             {selectedMode === "short-only" && (
// //               <Input
// //                 label="Take Profit Short (%)"
// //                 tooltip="Set the take profit percentage for short positions."
// //                 type="number"
// //                 value={botConfig.takeProfitShort}
// //                 onChange={(e) =>
// //                   onFinalFieldChange("takeProfitShort", e.target.value)
// //                 }
// //                 placeholder="10"
// //               />
// //             )}

// //             {/* BOTH SHOW (When not long-only & not short-only) */}
// //             {selectedMode !== "long-only" && selectedMode !== "short-only" && (
// //               <>
// //                 <Input
// //                   label="Take Profit Long (%)"
// //                   tooltip="Set the take profit percentage for long positions."
// //                   type="number"
// //                   value={botConfig.takeProfitLong}
// //                   onChange={(e) =>
// //                     onFinalFieldChange("takeProfitLong", e.target.value)
// //                   }
// //                   placeholder="10"
// //                 />
// //                 <Input
// //                   label="Take Profit Short (%)"
// //                   tooltip="Set the take profit percentage for short positions."
// //                   type="number"
// //                   value={botConfig.takeProfitShort}
// //                   onChange={(e) =>
// //                     onFinalFieldChange("takeProfitShort", e.target.value)
// //                   }
// //                   placeholder="10"
// //                 />
// //               </>
// //             )}

// //           </div>

// //           {isTakeProfitValid() && (
// //             <div className="mt-6 flex justify-end items-center">
// //               <Button variant="default" className="px-8" onClick={nextTab}>
// //                 Next
// //               </Button>
// //             </div>
// //           )}
// //         </div>
// //       );
// //     }

// //     /* ---------- FINAL SUBMIT ---------- */
// //     if (activeTab === "final") {
// //       const entry = conditions.entry?.[0] || {};
// //       const selectedApi = apis.find((a) => a.ApiID === entry.apiName);

// //       return (
// //         <div className="space-y-6">
// //           {/* Title */}
// //           <h4 className="text-xl font-bold text-center">
// //             Final Bot Configuration
// //           </h4>

// //           {/* 2-column grid */}
// //           <div className="bg-muted/50 p-5 rounded-lg">
// //             <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 text-sm">
// //               {/* ---- Row 1 ---- */}
// //               <div className="flex justify-between items-center">
// //                 <strong>Market:</strong>
// //                 <span>{botConfig.market?.toUpperCase()}</span>
// //               </div>

// //               <div className="flex justify-between items-center">
// //                 <strong>Mode:</strong>
// //                 <span>
// //                   {botConfig.tradingMode?.replace(/-/g, " ").toUpperCase()}
// //                 </span>
// //               </div>

// //               {/* ---- Row 2 ---- */}
// //               <div className="flex justify-between items-center">
// //                 <strong>Api Name:</strong>
// //                 <span>{selectedApi?.Api_Name || "-"}</span>
// //               </div>

// //               <div className="flex justify-between items-center">
// //                 <strong>Trade Type:</strong>
// //                 <span>{selectedApi?.Trade_Type || "-"}</span>
// //               </div>

// //               {/* ---- Row 3 ---- */}
// //               <div className="flex justify-between items-center">
// //                 <strong>Leverage:</strong>
// //                 <span>{entry.leverage || "-"}x</span>
// //               </div>

// //               <div className="flex justify-between items-center">
// //                 <strong>TP Type:</strong>
// //                 <span>
// //                   {tpTypeOptions.find((t) => t.value === entry.tp_type)
// //                     ?.label || "-"}
// //                 </span>
// //               </div>

// //               {/* ---- Row 4 ---- */}
// //               <div className="flex justify-between items-center">
// //                 <strong>Symbol:</strong>
// //                 <span>{entry.symbol || "-"}</span>
// //               </div>

// //               <div className="flex justify-between items-center">
// //                 <strong>Bot Name:</strong>
// //                 <span>{entry.bot_name || "-"}</span>
// //               </div>

// //               {/* ---- Row 5 ---- */}
// //               <div className="flex justify-between items-center">
// //                 <strong>Exchange:</strong>
// //                 <span>{entry.exchange || "-"}</span>
// //               </div>

// //               <div className="flex justify-between items-center">
// //                 <strong>Strategy:</strong>
// //                 <span>{selectedMainStrategy || "-"}</span>
// //               </div>

// //               <div className="flex justify-between items-center">
// //                 <strong>Investment Long:</strong>
// //                 <span>$ {entry.investment_long || "0"} </span>
// //               </div>

// //               {/* ---- Row 6 ---- */}
// //               <div className="flex justify-between items-center">
// //                 <strong>Investment Short:</strong>
// //                 <span>$ {entry.investment_short || "0"} </span>
// //               </div>

// //               <div className="flex justify-between items-center">
// //                 <strong>Take Profit Long:</strong>
// //                 <span>{botConfig.takeProfitLong}%</span>
// //               </div>

// //               {/* ---- Row 7 ---- */}
// //               <div className="flex justify-between items-center">
// //                 <strong>Take Profit Short:</strong>
// //                 <span>{botConfig.takeProfitShort}%</span>
// //               </div>

// //               <div className="flex justify-between items-center">
// //                 <strong>Stop Loss Long:</strong>
// //                 <span>{botConfig.stopLossLong}%</span>
// //               </div>

// //               {/* ---- Row 8 (last item spans full width on mobile) ---- */}
// //               <div className="flex justify-between items-center">
// //                 <strong>Stop Loss Short:</strong>
// //                 <span>{botConfig.stopLossShort}%</span>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       );
// //     }

// //     return null;
// //   };

// //   /* --------------------------------------------------------------
// //      TAB INDICATORS (non‑clickable)
// //   -------------------------------------------------------------- */
// //   const tabs = [
// //     { id: "entry", label: "Configuration", icon: "LogIn" },
// //     { id: "stoploss", label: "Stop Loss", icon: "ShieldOff" },
// //     { id: "takeprofit", label: "Take Profit", icon: "Target" },
// //     { id: "final", label: "Final Submit", icon: "CheckCircle" },
// //   ];

// //   return (
// //     <div className="space-y-6">
// //       <div className="text-center">
// //         <h3 className="text-2xl font-bold text-foreground mb-2">
// //           Configure Trading Conditions
// //         </h3>
// //         <p className="text-muted-foreground">Fill each step and click Next</p>
// //       </div>

// //       {/* Tab indicators */}
// //       <div className="flex justify-center gap-3">
// //         {tabs.map((tab, idx) => (
// //           <div
// //             key={tab.id}
// //             className={`flex items-center gap-2 px-4 py-2 rounded-full text-xs font-medium transition-all ${activeTab === tab.id
// //               ? "bg-primary text-primary-foreground"
// //               : idx < tabs.findIndex((t) => t.id === tab.id)
// //                 ? "bg-success/20 text-success"
// //                 : "bg-muted text-muted-foreground"
// //               }`}
// //           >
// //             <Icon name={tab.icon} size={14} />
// //             <span>{tab.label}</span>
// //           </div>
// //         ))}
// //       </div>

// //       {/* Content */}
// //       <div className="min-h-[400px] p-4">{renderTabContent()}</div>
// //     </div>
// //   );
// // };

// // export default TradingConditions;


// import React, { useContext, useEffect, useState } from "react";
// import Icon from "../../../components/AppIcon";
// import Button from "../../../components/ui/Button";
// import Select from "../../../components/ui/Select";
// import Input from "../../../components/ui/Input";
// import { DataContext } from "context/DataContext";
// import apiUtils from "utils/apiutils";

// // Custom Select to show proper value in input field
// const CustomSelect = ({ options, value, onChange, ...props }) => {
//   const selectedOption = options.find((opt) => opt.value === value);
//   const displayValue = selectedOption ? selectedOption.value : value;

//   return (
//     <Select
//       {...props}
//       options={options.map((opt) => ({
//         ...opt,
//         label: opt.dropdownLabel || opt.label,
//       }))}
//       value={displayValue}
//       onChange={onChange}
//     />
//   );
// };

// const TradingConditions = ({
//   conditions,
//   onConditionsChange,
//   botConfig,
//   selectedMainStrategy,
//   apis,
//   onFinalFieldChange,
//   selectedMode,
//   handleCreateBot,
// }) => {
//   const [activeTab, setActiveTab] = useState("entry");
//   const { myexchanges, coins, handegetcoins, handlegetexchanges } = useContext(DataContext);

//   const [exchanges, setExchanges] = useState([]);
//   const [symbols, setSymbols] = useState([]);
//   const [leverage, setLeverage] = useState([]);
//   const [isLoadingSymbols, setIsLoadingSymbols] = useState(false);
//   const [isLoadingLeverage, setIsLoadingLeverage] = useState(false);

//   // Fetch exchanges
//   const handegetExchanges = async () => {
//     try {
//       const resp = await apiUtils.post("/api/get_exchange_name", { showToast: false });
//       if (resp?.Success) setExchanges(resp.Success);
//     } catch (e) {
//       console.error("Error fetching exchanges:", e);
//     }
//   };

//   // Fetch symbols based on exchange
//   const handegetSymbols = async (exchange) => {
//     if (!exchange) {
//       setSymbols([]);
//       return;
//     }
//     setIsLoadingSymbols(true);
//     try {
//       const resp = await apiUtils.post("/api/get_exchange_symbols", {
//         exchange,
//         exchange_type: botConfig.exchange_type || "spot",
//       }, { showToast: false });
//       if (resp?.Success?.Symbols) {
//         setSymbols(resp.Success.Symbols);
//       }
//     } catch (e) {
//       console.error("Error fetching symbols:", e);
//     } finally {
//       setIsLoadingSymbols(false);
//     }
//   };

//   // Fetch leverage options
//   const handegetExchangesLeverage = async () => {
//     setIsLoadingLeverage(true);
//     try {
//       const resp = await apiUtils.post("/bot/view_leverage_dropdown", { showToast: false });
//       if (resp?.Success?.Static_List) {
//         setLeverage(resp.Static_List);
//       } else {
//         setLeverage(["5", "10", "20"]); // fallback
//       }
//     } catch (e) {
//       console.error("Error fetching leverage:", e);
//       setLeverage(["5", "10", "20"]);
//     } finally {
//       setIsLoadingLeverage(false);
//     }
//   };

//   useEffect(() => {
//     handegetcoins?.();
//     handegetExchanges?.();
//     handlegetexchanges?.();
//     handegetExchangesLeverage();
//   }, []);

//   useEffect(() => {
//     const selectedExchange = conditions.entry?.[0]?.exchange;
//     if (selectedExchange) {
//       handegetSymbols(selectedExchange);
//     } else {
//       setSymbols([]);
//     }
//   }, [conditions.entry?.[0]?.exchange]);

//   // Options
//   const apiNameOptions = apis.map((a) => ({
//     value: a.ApiID,
//     label: a.Api_Name,
//     exchange: a.Exchange,
//   }));

//   const leverageOptions = leverage.map((v) => ({ value: v, label: v }));
//   const tpTypeOptions = [
//     { value: "Pair_Price", label: "Pair Price" },
//     { value: "Pair_Value", label: "Pair Value" },
//   ];

//   const exchangeOptions = exchanges.map((ex) => ({
//     value: ex,
//     searchableText: ex,
//     label: <div className="flex items-center gap-2"><span>{ex.toUpperCase()}</span></div>,
//   }));

//   const coinOptions = symbols.map((c) => ({
//     value: c,
//     searchableText: c,
//     label: c.toUpperCase(),
//     dropdownLabel: <div className="flex items-center gap-2"><span>{c.toUpperCase()}</span></div>,
//   }));

//   // Condition Helpers
//   const addCondition = (type) => {
//     const newCond = {
//       id: Date.now(),
//       apiName: "",
//       leverage: "",
//       symbol: "",
//       bot_name: "",
//       tp_type: "",
//       exchange: "",
//       investment_long: "",
//       investment_short: "",
//       enabled: true,
//     };
//     onConditionsChange({
//       ...conditions,
//       [type]: [...(conditions[type] || []), newCond],
//     });
//   };

//   const updateCondition = (type, id, field, value) => {
//     const updated = (conditions[type] || []).map((c) =>
//       c.id === id ? { ...c, [field]: value } : c
//     );
//     onConditionsChange({ ...conditions, [type]: updated });

//     if (field === "exchange" && type === "entry") {
//       handegetSymbols(value);
//       onConditionsChange({
//         ...conditions,
//         [type]: updated.map((c) => (c.id === id ? { ...c, symbol: "" } : c)),
//       });
//     }
//   };

//   const removeCondition = (type, id) => {
//     const filtered = (conditions[type] || []).filter((c) => c.id !== id);
//     onConditionsChange({ ...conditions, [type]: filtered });
//   };

//   // Tab Navigation
//   const tabOrder = ["entry", "stoploss", "takeprofit", "final"];
//   const nextTab = () => {
//     const idx = tabOrder.indexOf(activeTab);
//     if (idx < tabOrder.length - 1) setActiveTab(tabOrder[idx + 1]);
//   };

//   // Validation Functions
//   const isEntryValid = () => {
//     const list = conditions.entry || [];
//     return (
//       list.length > 0 &&
//       list.every((c) =>
//         c.apiName &&
//         c.leverage &&
//         c.symbol &&
//         c.bot_name &&
//         c.exchange &&
//         (selectedMainStrategy !== "Liquidation" || c.tp_type)
//       )
//     );
//   };

//   const isStopLossValid = () => {
//     if (selectedMode === "long-only") return !!botConfig.stopLossLong;
//     if (selectedMode === "short-only") return !!botConfig.stopLossShort;
//     return !!botConfig.stopLossLong && !!botConfig.stopLossShort;
//   };

//   const isTakeProfitValid = () => {
//     if (selectedMode === "long-only") return !!botConfig.takeProfitLong;
//     if (selectedMode === "short-only") return !!botConfig.takeProfitShort;
//     return !!botConfig.takeProfitLong && !!botConfig.takeProfitShort;
//   };

//   const isFinalValid = () => {
//     return isEntryValid() && isStopLossValid() && isTakeProfitValid();
//   };

//   // Render Tabs
//   const renderTabContent = () => {
//     if (activeTab === "entry") {
//       const list = conditions.entry || [];

//       return (
//         <div className="space-y-6">
//           {list.length === 0 ? (
//             <div className="text-center py-12">
//               <Button onClick={() => addCondition("entry")} iconName="Plus" iconPosition="left">
//                 Add Configuration
//               </Button>
//             </div>
//           ) : (
//             list.map((cond) => {
//               const selectedApi = apis.find((a) => a.ApiID === cond.apiName);

//               return (
//                 <div key={cond.id} className="bg-card border border-border rounded-lg p-6">
//                   <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
//                     <Select
//                       label="Api Name"
//                       options={apiNameOptions}
//                       value={cond.apiName ?? ""}
//                       onChange={(v) => {
//                         const api = apiNameOptions.find((a) => a.value === v);
//                         const updated = conditions.entry.map((c) =>
//                           c.id === cond.id
//                             ? { ...c, apiName: v, exchange: api?.exchange || "" }
//                             : c
//                         );
//                         onConditionsChange({ ...conditions, entry: updated });
//                       }}
//                       placeholder="Select Api"
//                     />

//                     <Select
//                       label="Leverage (x)"
//                       options={leverageOptions}
//                       value={cond.leverage ?? ""}
//                       onChange={(v) => updateCondition("entry", cond.id, "leverage", v)}
//                       placeholder={isLoadingLeverage ? "Loading..." : "Select Leverage"}
//                       disabled={isLoadingLeverage}
//                     />

//                     <Select
//                       label="Exchange"
//                       options={exchangeOptions}
//                       value={cond.exchange ?? ""}
//                       onChange={(v) => updateCondition("entry", cond.id, "exchange", v)}
//                       placeholder="Select Exchange"
//                       disabled={!!cond.apiName}
//                     />

//                     <CustomSelect
//                       label="Symbol"
//                       options={coinOptions}
//                       value={cond.symbol ?? ""}
//                       onChange={(v) => updateCondition("entry", cond.id, "symbol", v)}
//                       placeholder={isLoadingSymbols ? "Loading..." : "Select Symbol"}
//                       disabled={!cond.exchange || isLoadingSymbols}
//                     />

//                     <Input
//                       label="Bot Name"
//                       value={cond.bot_name ?? ""}
//                       onChange={(e) => updateCondition("entry", cond.id, "bot_name", e.target.value)}
//                       placeholder="Enter bot name"
//                     />

//                     {selectedMainStrategy === "Liquidation" && (
//                       <Select
//                         label="TP Type"
//                         options={tpTypeOptions}
//                         value={cond.tp_type ?? ""}
//                         onChange={(v) => updateCondition("entry", cond.id, "tp_type", v)}
//                         placeholder="Select TP Type"
//                       />
//                     )}

//                     {selectedMode !== "short-only" && (
//                       <Input
//                         label="Investment Long ($)"
//                         type="number"
//                         value={cond.investment_long ?? ""}
//                         onChange={(e) => updateCondition("entry", cond.id, "investment_long", e.target.value)}
//                         placeholder="0.00"
//                       />
//                     )}

//                     {selectedMode !== "long-only" && (
//                       <Input
//                         label="Investment Short ($)"
//                         type="number"
//                         value={cond.investment_short ?? ""}
//                         onChange={(e) => updateCondition("entry", cond.id, "investment_short", e.target.value)}
//                         placeholder="0.00"
//                       />
//                     )}
//                   </div>
//                 </div>
//               );
//             })
//           )}

//           {/* Next Button - Only when valid */}
//           {isEntryValid() && (
//             <div className="mt-8 flex justify-end">
//               <Button variant="default" size="lg" onClick={nextTab}>
//                 Next
//               </Button>
//             </div>
//           )}
//         </div>
//       );
//     }

//     if (activeTab === "stoploss") {
//       return (
//         <div className="space-y-8">
//           <h4 className="text-xl font-semibold text-center">Set Stop Loss (%)</h4>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
//             {selectedMode !== "short-only" && (
//               <Input
//                 label="Stop Loss Long (%)"
//                 type="number"
//                 value={botConfig.stopLossLong || ""}
//                 onChange={(e) => onFinalFieldChange("stopLossLong", e.target.value)}
//                 placeholder="5"
//               />
//             )}
//             {selectedMode !== "long-only" && (
//               <Input
//                 label="Stop Loss Short (%)"
//                 type="number"
//                 value={botConfig.stopLossShort || ""}
//                 onChange={(e) => onFinalFieldChange("stopLossShort", e.target.value)}
//                 placeholder="5"
//               />
//             )}
//           </div>

//           {isStopLossValid() && (
//             <div className="flex justify-end">
//               <Button variant="default" size="lg" onClick={nextTab}>
//                 Next
//               </Button>
//             </div>
//           )}
//         </div>
//       );
//     }

//     if (activeTab === "takeprofit") {
//       return (
//         <div className="space-y-8">
//           <h4 className="text-xl font-semibold text-center">Set Take Profit (%)</h4>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
//             {selectedMode !== "short-only" && (
//               <Input
//                 label="Take Profit Long (%)"
//                 type="number"
//                 value={botConfig.takeProfitLong || ""}
//                 onChange={(e) => onFinalFieldChange("takeProfitLong", e.target.value)}
//                 placeholder="10"
//               />
//             )}
//             {selectedMode !== "long-only" && (
//               <Input
//                 label="Take Profit Short (%)"
//                 type="number"
//                 value={botConfig.takeProfitShort || ""}
//                 onChange={(e) => onFinalFieldChange("takeProfitShort", e.target.value)}
//                 placeholder="10"
//               />
//             )}
//           </div>

//           {isTakeProfitValid() && (
//             <div className="flex justify-end">
//               <Button variant="default" size="lg" onClick={nextTab}>
//                 Next
//               </Button>
//             </div>
//           )}
//         </div>
//       );
//     }

//     if (activeTab === "final") {
//       const entry = conditions.entry?.[0] || {};
//       const selectedApi = apis.find((a) => a.ApiID === entry.apiName);

//       return (
//         <div className="space-y-10">
//           <h4 className="text-2xl font-bold text-center">Final Bot Configuration</h4>

//           {/* Summary - Always Visible */}
//           <div className="bg-muted/50 rounded-xl p-8 max-w-4xl mx-auto">
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
//               <div className="flex justify-between"><strong>Market:</strong> <span>{botConfig.market?.toUpperCase()}</span></div>
//               <div className="flex justify-between"><strong>Mode:</strong> <span>{botConfig.tradingMode?.replace(/-/g, " ").toUpperCase()}</span></div>
//               <div className="flex justify-between"><strong>Api Name:</strong> <span>{selectedApi?.Api_Name || "-"}</span></div>
//               <div className="flex justify-between"><strong>Trade Type:</strong> <span>{selectedApi?.Trade_Type || "-"}</span></div>
//               <div className="flex justify-between"><strong>Leverage:</strong> <span>{entry.leverage ? `${entry.leverage}x` : "-"}</span></div>
//               <div className="flex justify-between"><strong>TP Type:</strong> <span>{tpTypeOptions.find(t => t.value === entry.tp_type)?.label || "-"}</span></div>
//               <div className="flex justify-between"><strong>Symbol:</strong> <span>{entry.symbol || "-"}</span></div>
//               <div className="flex justify-between"><strong>Bot Name:</strong> <span>{entry.bot_name || "-"}</span></div>
//               <div className="flex justify-between"><strong>Exchange:</strong> <span>{entry.exchange || "-"}</span></div>
//               <div className="flex justify-between"><strong>Strategy:</strong> <span>{selectedMainStrategy || "-"}</span></div>
//               <div className="flex justify-between"><strong>Investment Long:</strong> <span>$ {entry.investment_long || "0"}</span></div>
//               <div className="flex justify-between"><strong>Investment Short:</strong> <span>$ {entry.investment_short || "0"}</span></div>
//               <div className="flex justify-between"><strong>Take Profit Long:</strong> <span>{botConfig.takeProfitLong || 0}%</span></div>
//               <div className="flex justify-between"><strong>Take Profit Short:</strong> <span>{botConfig.takeProfitShort || 0}%</span></div>
//               <div className="flex justify-between"><strong>Stop Loss Long:</strong> <span>{botConfig.stopLossLong || 0}%</span></div>
//               <div className="flex justify-between"><strong>Stop Loss Short:</strong> <span>{botConfig.stopLossShort || 0}%</span></div>
//             </div>
//           </div>

//           {/* Create Bot Button - Only when fully valid */}
//           {isFinalValid() ? (
//             <div className="flex justify-center">
//               <Button
//                 variant="default"
//                 size="lg"
//                 className="px-16 py-7 text-lg font-semibold"
//                 onClick={handleCreateBot}
//               >
//                 Create Bot
//               </Button>
//             </div>
//           ) : (
//             <div className="text-center text-muted-foreground text-lg">
//               Please complete all previous steps to enable bot creation.
//             </div>
//           )}
//         </div>
//       );
//     }

//     return null;
//   };

//   const tabs = [
//     { id: "entry", label: "Configuration", icon: "Settings" },
//     { id: "stoploss", label: "Stop Loss", icon: "ShieldOff" },
//     { id: "takeprofit", label: "Take Profit", icon: "Target" },
//     { id: "final", label: "Review & Submit", icon: "CheckCircle" },
//   ];

//   return (
//     <div className="max-w-6xl mx-auto space-y-10">
//       <div className="text-center">
//         <h3 className="text-3xl font-bold text-foreground mb-3">
//           Configure Trading Conditions
//         </h3>
//         <p className="text-muted-foreground">Complete each step to create your bot</p>
//       </div>

//       {/* Tab Indicators */}
//       <div className="flex justify-center gap-4 flex-wrap">
//         {tabs.map((tab, idx) => {
//           const isActive = activeTab === tab.id;
//           const isCompleted = tabOrder.indexOf(tab.id) < tabOrder.indexOf(activeTab);

//           return (
//             <div
//               key={tab.id}
//               className={`flex items-center gap-3 px-6 py-3 rounded-full text-sm font-medium transition-all ${
//                 isActive
//                   ? "bg-primary text-primary-foreground shadow-lg"
//                   : isCompleted
//                   ? "bg-success/20 text-success"
//                   : "bg-muted text-muted-foreground"
//               }`}
//             >
//               <Icon name={tab.icon} size={16} />
//               <span>{tab.label}</span>
//             </div>
//           );
//         })}
//       </div>

//       {/* Main Content */}
//       <div className="bg-background rounded-xl shadow-sm border border-border p-8 ">
//         {renderTabContent()}
//       </div>
//     </div>
//   );
// };

// export default TradingConditions;

import React, { useContext, useEffect, useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Select from "../../../components/ui/Select";
import Input from "../../../components/ui/Input";
import { DataContext } from "context/DataContext";
import apiUtils from "utils/apiutils";

// Custom Select to show proper value in input field
const CustomSelect = ({ options, value, onChange, ...props }) => {
  const selectedOption = options.find((opt) => opt.value === value);
  const displayValue = selectedOption ? selectedOption.value : value;

  return (
    <Select
      {...props}
      options={options.map((opt) => ({
        ...opt,
        label: opt.dropdownLabel || opt.label,
      }))}
      value={displayValue}
      onChange={onChange}
    />
  );
};

const TradingConditions = ({
  conditions,
  onConditionsChange,
  botConfig,
  selectedMainStrategy,
  apis,
  onFinalFieldChange,
  selectedMode,
  handleCreateBot,
}) => {
  const [activeTab, setActiveTab] = useState("entry");
  const { myexchanges, coins, handegetcoins, handlegetexchanges } = useContext(DataContext);

  const [exchanges, setExchanges] = useState([]);
  const [symbols, setSymbols] = useState([]);
  const [leverage, setLeverage] = useState([]);
  const [isLoadingSymbols, setIsLoadingSymbols] = useState(false);
  const [isLoadingLeverage, setIsLoadingLeverage] = useState(false);

  // NEW: Subsequent Multiplier
  const [subsequentMultiplier, setSubsequentMultiplier] = useState("2");

  // Fetch exchanges
  const handegetExchanges = async () => {
    try {
      const resp = await apiUtils.post("/api/get_exchange_name", { showToast: false });
      if (resp?.Success) setExchanges(resp.Success);
    } catch (e) {
      console.error("Error fetching exchanges:", e);
    }
  };

  // Fetch symbols
  const handegetSymbols = async (exchange) => {
    if (!exchange) {
      setSymbols([]);
      return;
    }
    setIsLoadingSymbols(true);
    try {
      const resp = await apiUtils.post("/api/get_exchange_symbols", {
        exchange,
        exchange_type: botConfig.exchange_type || "spot",
      }, { showToast: false });
      if (resp?.Success?.Symbols) {
        setSymbols(resp.Success.Symbols);
      }
    } catch (e) {
      console.error("Error fetching symbols:", e);
    } finally {
      setIsLoadingSymbols(false);
    }
  };

  // Fetch leverage
  const handegetExchangesLeverage = async () => {
    setIsLoadingLeverage(true);
    try {
      const resp = await apiUtils.post("/bot/view_leverage_dropdown", { showToast: false });
      if (resp?.Success?.Static_List) {
        setLeverage(resp.Static_List);
      } else {
        setLeverage(["5", "10", "20"]);
      }
    } catch (e) {
      console.error("Error fetching leverage:", e);
      setLeverage(["5", "10", "20"]);
    } finally {
      setIsLoadingLeverage(false);
    }
  };

  useEffect(() => {
    handegetcoins?.();
    handegetExchanges?.();
    handlegetexchanges?.();
    handegetExchangesLeverage();
  }, []);

  useEffect(() => {
    const selectedExchange = conditions.entry?.[0]?.exchange;
    if (selectedExchange) {
      handegetSymbols(selectedExchange);
    } else {
      setSymbols([]);
    }
  }, [conditions.entry?.[0]?.exchange]);

  // Options
  const apiNameOptions = apis.map((a) => ({
    value: a.ApiID,
    label: a.Api_Name,
    exchange: a.Exchange,
  }));

  const leverageOptions = leverage.map((v) => ({ value: v, label: v }));
  const tpTypeOptions = [
    { value: "Pair_Price", label: "Pair Price" },
    { value: "Pair_Value", label: "Pair Value" },
  ];

   const slTypeOptions = [
    { value: "TRIGGERED_PRICE", label: "Triggered Price" },
    { value: "ENTRY_PRICE", label: "Entry Price" },
  ];

  const exchangeOptions = exchanges.map((ex) => ({
    value: ex,
    searchableText: ex,
    label: <div className="flex items-center gap-2"><span>{ex.toUpperCase()}</span></div>,
  }));

  const coinOptions = symbols.map((c) => ({
    value: c,
    searchableText: c,
    label: c.toUpperCase(),
    dropdownLabel: <div className="flex items-center gap-2"><span>{c.toUpperCase()}</span></div>,
  }));

  // Condition Helpers
  const addCondition = (type) => {
    const newCond = {
      id: Date.now(),
      apiName: "",
      leverage: "",
      symbol: "",
      bot_name: "",
      tp_type: "",
      exchange: "",
      investment_long: "",
      investment_short: "",
      enabled: true,
    };
    onConditionsChange({
      ...conditions,
      [type]: [...(conditions[type] || []), newCond],
    });
  };

  const updateCondition = (type, id, field, value) => {
    const updated = (conditions[type] || []).map((c) =>
      c.id === id ? { ...c, [field]: value } : c
    );
    onConditionsChange({ ...conditions, [type]: updated });

    if (field === "exchange" && type === "entry") {
      handegetSymbols(value);
      onConditionsChange({
        ...conditions,
        [type]: updated.map((c) => (c.id === id ? { ...c, symbol: "" } : c)),
      });
    }
  };

  // Tab Navigation
  const tabOrder = ["entry", "stoploss", "takeprofit", "final"];
  const nextTab = () => {
    const idx = tabOrder.indexOf(activeTab);
    if (idx < tabOrder.length - 1) setActiveTab(tabOrder[idx + 1]);
  };

  // Validation
  const isEntryValid = () => {
    const list = conditions.entry || [];
    return (
      list.length > 0 &&
      list.every((c) =>
        c.apiName &&
        c.leverage &&
        c.symbol &&
        c.bot_name &&
        c.exchange &&
        (selectedMainStrategy !== "Liquidation" || c.tp_type)
      )
    );
  };

  const isStopLossValid = () => {
    if (selectedMode === "long-only") return !!botConfig.stopLossLong;
    if (selectedMode === "short-only") return !!botConfig.stopLossShort;
    return !!botConfig.stopLossLong && !!botConfig.stopLossShort;
  };

  const isTakeProfitValid = () => {
    const tpValid = selectedMode === "long-only"
      ? !!botConfig.takeProfitLong
      : selectedMode === "short-only"
        ? !!botConfig.takeProfitShort
        : !!botConfig.takeProfitLong && !!botConfig.takeProfitShort;

    return tpValid && !!subsequentMultiplier && parseFloat(subsequentMultiplier) >= 1;
  };

  const isFinalValid = () => {
    return isEntryValid() && isStopLossValid() && isTakeProfitValid();
  };

  // Render Content
  const renderTabContent = () => {
    if (activeTab === "entry") {
      const list = conditions.entry || [];

      return (
        <div className="space-y-6">
          {list.length === 0 ? (
            <div className="text-center py-12">
              <Button onClick={() => addCondition("entry")} iconName="Plus" iconPosition="left">
                Add Configuration
              </Button>
            </div>
          ) : (
            list.map((cond) => {
              const selectedApi = apis.find((a) => a.ApiID === cond.apiName);

              return (
                <div key={cond.id} className="bg-card border border-border rounded-lg p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <Select
                      label="Api Name"
                      options={apiNameOptions}
                      value={cond.apiName ?? ""}
                      onChange={(v) => {
                        const api = apiNameOptions.find((a) => a.value === v);
                        const updated = conditions.entry.map((c) =>
                          c.id === cond.id
                            ? { ...c, apiName: v, exchange: api?.exchange || "" }
                            : c
                        );
                        onConditionsChange({ ...conditions, entry: updated });
                      }}
                      placeholder="Select Api"
                    />

                    <Select
                      label="Leverage (x)"
                      options={leverageOptions}
                      value={cond.leverage ?? ""}
                      onChange={(v) => updateCondition("entry", cond.id, "leverage", v)}
                      placeholder={isLoadingLeverage ? "Loading..." : "Select Leverage"}
                      disabled={isLoadingLeverage}
                    />

                    <Select
                      label="Exchange"
                      options={exchangeOptions}
                      value={cond.exchange ?? ""}
                      onChange={(v) => updateCondition("entry", cond.id, "exchange", v)}
                      placeholder="Select Exchange"
                      disabled={!!cond.apiName}
                    />

                    <CustomSelect
                      label="Symbol"
                      options={coinOptions}
                      value={cond.symbol ?? ""}
                      onChange={(v) => updateCondition("entry", cond.id, "symbol", v)}
                      placeholder={isLoadingSymbols ? "Loading..." : "Select Symbol"}
                      disabled={!cond.exchange || isLoadingSymbols}
                    />

                    <Input
                      label="Bot Name"
                      value={cond.bot_name ?? ""}
                      onChange={(e) => updateCondition("entry", cond.id, "bot_name", e.target.value)}
                      placeholder="Enter bot name"
                    />

                    {selectedMainStrategy === "Liquidation" && (
                      <>
                        <Select
                          label="TP Type"
                          options={tpTypeOptions}
                          value={cond.tp_type ?? ""}
                          onChange={(v) => updateCondition("entry", cond.id, "tp_type", v)}
                          placeholder="Select TP Type"
                        />
                        <Input
                          label="Subsequent Multiplier (x)"
                          tooltip="Multiplier for next take profit levels (e.g., 2x, 3x). Used in grid/trailing strategies."
                          type="number"
                          min="1"
                          step="0.1"
                          value={cond.subsequent_multiplier ?? ""}
                          onChange={(e) => updateCondition("entry", cond.id, "subsequent_multiplier", e.target.value)}
                          placeholder="2"
                        />
                      </>
                    )}
                    {selectedMainStrategy === "TP_SL" && (
                      <Select
                        label="SL Type"
                        options={slTypeOptions}
                        value={cond.sl_type ?? ""}
                        onChange={(v) => updateCondition("entry", cond.id, "sl_type", v)}
                        placeholder="Select SL Type"
                      />
                    )}


                    {selectedMode !== "short-only" && (
                      <Input
                        label="Investment Long ($)"
                        type="number"
                        value={cond.investment_long ?? ""}
                        onChange={(e) => updateCondition("entry", cond.id, "investment_long", e.target.value)}
                        placeholder="0.00"
                      />
                    )}

                    {selectedMode !== "long-only" && (
                      <Input
                        label="Investment Short ($)"
                        type="number"
                        value={cond.investment_short ?? ""}
                        onChange={(e) => updateCondition("entry", cond.id, "investment_short", e.target.value)}
                        placeholder="0.00"
                      />
                    )}

                    {/* <div className="max-w-md mx-auto mt-6"> */}

                    {/* </div> */}

                  </div>
                </div>
              );
            })
          )}

          {isEntryValid() && (
            <div className="mt-8 flex justify-end">
              <Button variant="default" size="lg" onClick={nextTab}>
                Next
              </Button>
            </div>
          )}
        </div>
      );
    }

    if (activeTab === "stoploss") {
      return (
        <div className="space-y-8">
          <h4 className="text-xl font-semibold text-center">Set Stop Loss (%)</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            {selectedMode !== "short-only" && (
              <Input
                label="Stop Loss Long (%)"
                type="number"
                value={botConfig.stopLossLong || ""}
                onChange={(e) => onFinalFieldChange("stopLossLong", e.target.value)}
                placeholder="5"
              />
            )}
            {selectedMode !== "long-only" && (
              <Input
                label="Stop Loss Short (%)"
                type="number"
                value={botConfig.stopLossShort || ""}
                onChange={(e) => onFinalFieldChange("stopLossShort", e.target.value)}
                placeholder="5"
              />
            )}
          </div>

          {isStopLossValid() && (
            <div className="flex justify-end">
              <Button variant="default" size="lg" onClick={nextTab}>
                Next
              </Button>
            </div>
          )}
        </div>
      );
    }

    if (activeTab === "takeprofit") {
      return (
        <div className="space-y-8">
          <h4 className="text-xl font-semibold text-center">Set Take Profit & Multiplier</h4>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            {selectedMode !== "short-only" && (
              <Input
                label="Take Profit Long (%)"
                type="number"
                value={botConfig.takeProfitLong || ""}
                onChange={(e) => onFinalFieldChange("takeProfitLong", e.target.value)}
                placeholder="10"
              />
            )}
            {selectedMode !== "long-only" && (
              <Input
                label="Take Profit Short (%)"
                type="number"
                value={botConfig.takeProfitShort || ""}
                onChange={(e) => onFinalFieldChange("takeProfitShort", e.target.value)}
                placeholder="10"
              />
            )}
          </div>

          {/* Subsequent Multiplier */}

          {isTakeProfitValid() && (
            <div className="flex justify-end mt-8">
              <Button variant="default" size="lg" onClick={nextTab}>
                Next
              </Button>
            </div>
          )}
        </div>
      );
    }

    if (activeTab === "final") {
      const entry = conditions.entry?.[0] || {};
      const selectedApi = apis.find((a) => a.ApiID === entry.apiName);

      return (
        <div className="space-y-10">
          <h4 className="text-2xl font-bold text-center">Final Bot Configuration</h4>

          <div className="bg-muted/50 rounded-xl p-8 max-w-4xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
              <div className="flex justify-between"><strong>Market:</strong> <span>{botConfig.market?.toUpperCase() || "-"}</span></div>
              <div className="flex justify-between"><strong>Mode:</strong> <span>{botConfig.tradingMode?.replace(/-/g, " ").toUpperCase() || "-"}</span></div>
              <div className="flex justify-between"><strong>Api Name:</strong> <span>{selectedApi?.Api_Name || "-"}</span></div>
              <div className="flex justify-between"><strong>Trade Type:</strong> <span>{selectedApi?.Trade_Type || "-"}</span></div>
              <div className="flex justify-between"><strong>Leverage:</strong> <span>{entry.leverage ? `${entry.leverage}x` : "-"}</span></div>
              <div className="flex justify-between"><strong>TP Type:</strong> <span>{tpTypeOptions.find(t => t.value === entry.tp_type)?.label || "-"}</span></div>
              <div className="flex justify-between"><strong>SL Type:</strong> <span>{slTypeOptions.find(t => t.value === entry.sl_type)?.label || "-"}</span></div>
              <div className="flex justify-between"><strong>Symbol:</strong> <span>{entry.symbol || "-"}</span></div>
              <div className="flex justify-between"><strong>Bot Name:</strong> <span>{entry.bot_name || "-"}</span></div>
              <div className="flex justify-between"><strong>Exchange:</strong> <span>{entry.exchange || "-"}</span></div>
              <div className="flex justify-between"><strong>Strategy:</strong> <span>{selectedMainStrategy || "-"}</span></div>
              <div className="flex justify-between"><strong>Investment Long:</strong> <span>$ {entry.investment_long || "0"}</span></div>
              <div className="flex justify-between"><strong>Investment Short:</strong> <span>$ {entry.investment_short || "0"}</span></div>
              <div className="flex justify-between"><strong>Take Profit Long:</strong> <span>{botConfig.takeProfitLong || 0}%</span></div>
              <div className="flex justify-between"><strong>Take Profit Short:</strong> <span>{botConfig.takeProfitShort || 0}%</span></div>
              <div className="flex justify-between"><strong>Stop Loss Long:</strong> <span>{botConfig.stopLossLong || 0}%</span></div>
              <div className="flex justify-between"><strong>Stop Loss Short:</strong> <span>{botConfig.stopLossShort || 0}%</span></div>
              <div className="flex justify-between ">
                <strong>Subsequent Multiplier:</strong>
                <span>{subsequentMultiplier || "-"}x</span>
              </div>
            </div>
          </div>

          {isFinalValid() ? (
            <div className="flex justify-center">
              <Button
                variant="default"
                size="lg"
                className="px-16 py-7 text-lg font-semibold"
                onClick={() => handleCreateBot({ subsequent_multiplier: subsequentMultiplier })}
              >
                Create Bot
              </Button>
            </div>
          ) : (
            <div className="text-center text-muted-foreground text-lg">
              Please complete all previous steps to create the bot.
            </div>
          )}
        </div>
      );
    }

    return null;
  };

  const tabs = [
    { id: "entry", label: "Configuration", icon: "Settings" },
    { id: "stoploss", label: "Stop Loss", icon: "ShieldOff" },
    { id: "takeprofit", label: "Take Profit", icon: "Target" },
    { id: "final", label: "Review & Submit", icon: "CheckCircle" },
  ];

  return (
    <div className="max-w-6xl mx-auto space-y-10 py-8">
      <div className="text-center">
        <h3 className="text-3xl font-bold text-foreground mb-3">
          Configure Trading Conditions
        </h3>
        <p className="text-muted-foreground">Complete each step to create your bot</p>
      </div>

      <div className="flex justify-center gap-4 flex-wrap">
        {tabs.map((tab, idx) => {
          const isActive = activeTab === tab.id;
          const isCompleted = tabOrder.indexOf(tab.id) < tabOrder.indexOf(activeTab);

          return (
            <div
              key={tab.id}
              className={`flex items-center gap-3 px-6 py-3 rounded-full text-sm font-medium transition-all ${isActive
                ? "bg-primary text-primary-foreground shadow-lg"
                : isCompleted
                  ? "bg-success/20 text-success"
                  : "bg-muted text-muted-foreground"
                }`}
            >
              <Icon name={tab.icon} size={16} />
              <span>{tab.label}</span>
            </div>
          );
        })}
      </div>

      <div className="bg-background rounded-xl shadow-sm border border-border p-8 ">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default TradingConditions;